module.exports = __webpack_public_path__ + "img/boy content.f1875aab.png";